<img 
    [src]="createPath()"
    alt="Taxi"
    [style]="calculateSize()"
    alt="" srcset="">